<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div style="margin:2%;" >
    <div class="panel panel-default">
   <div class="panel-body">
   <form class="form-horizontal" *ngIf=data >
    <div class="form-group">
    <label for="name">Name:</label>
   <input [(ngModel)]='data.name' type="text" name="name" id="name"  class="form-control" required>
   </div>
  <div class="form-group">
   <label for="mobile">Mobile</label>
  <input [(ngModel)]='data.mobile' type="text" name="mobile" id="mobile"  class="form-control" required>
  </div>
<div class="form-group">
<label for="bio">Bio</label>
<input [(ngModel)]='data.bio' type="text" name="bio" id="bio"  class="form-control" required>
</div>
<button type="submit" class="btn btn-success" (click)="editUserName()" >Update Info</button>
<button mat-button mat-dialog-close >Cancel</button>
</form>
</div>
</div>
</div>








<!--<div >
<md-card fullscreen >
    <md-card-content>
        
    <form   [formGroup]="manageprofileform"  (ngSubmit)="editUserName()">
    <div class="form-group">
    <label  for="name"> Name </label> 
    <input [(ngModel)]='data.name'  type="text" name="name" id="name" [(ngModel)]="manageprofileform.name" class="form-control" formControlName="name" > 
    </div>
    <div  *ngIf="( manageprofileform.get('name').hasError('required') ) && manageprofileform.get('name').touched">                
</div>

<div class="form-group">
  <label for="mobile">Mobile</label>
  <input  [(ngModel)]='data.mobile' type="mobile" name="mobile" id="mobile" [(ngModel)]="manageprofileform.mobile" class="form-control" formControlName="mobile" required>
  </div>
  
  <div  *ngIf="( manageprofileform.get('mobile').hasError('required')  || manageprofileform.get('mobile').hasError('minLength') ) && manageprofileform.get('mobile').touched">
    
    <div class="error" style="color:red;font-size:10px" *ngIf="manageprofileform.get('mobile').hasError('minLength') && manageprofileform.get('mobile').touched">
    This is not a valid Mobile Number
    </div>
  
  </div>
  <div>
  <label  for="bio"> About Me </label> 
  <input [(ngModel)]='data.bio'  type="text" name="bio" id="bio" [(ngModel)]="manageprofileform.bio" class="form-control" formControlName="bio" > 
 </div>

    <button  type='submit' class="btn btn-success" (click)="editUserName()" > Update </button>
    <button  class="btn btn-success3" (click)="closeDialog()"> Cancel  </button>
 
    </form>
    </md-card-content>
    </md-card>
    
  </div>-->